export const getFileExtension = (file: File) => {
  if (!file?.name) {
    return;
  }

  return file.name.split('.').pop()?.toLowerCase();
};
